class AnchorScroll extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      this.header = document.querySelector('.shopify-section-header-sticky');
      document.addEventListener('click', this.onClick);
      this.handleInitialHash();
    });
  }

  onClick(event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    this.scrollToTarget(target);
  }

  scrollToTarget(target) {
    const headerHeight = this.header ? this.header.offsetHeight : 0;

    const offsetPosition =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'instant'
    });
  }

  handleInitialHash() {
    if (!window.location.hash) return;

    const target = document.querySelector(window.location.hash);
    if (!target) return;

    this.scrollToTarget(target);
  }
}

customElements.define('anchor-scroll', AnchorScroll);